import i18n from '../../locales/index'
import restful from '../vuex'

const state = {
  ...restful.states('printer_config')
}

const getters = {
  ...restful.getters('printer_config')
}

const actions = {
  ...restful.actions('printer_configs')
}

const mutations = {
  ...restful.mutations('printer_config')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
